module.exports = __webpack_public_path__ + "static/media/Ingredient2024.1e70e842.png";